export class ToolAvailabilityStatus {
    static AVAILABLE = "Available";
    static NOT_AVAILABLE_MANUAL = "NotAvailableManual";
    static NOT_AVAILABLE_AUTOMATIC = "NotAvailableAutomatic";
}
